import { useMemo } from 'react'

import { ActionSnippetType } from '@/app/module/campaigns/types'
import { useGetSnippets } from '@/app/module/user/hooks/use-get-snippets'

export const useActionSnippets = () => {
  const snippets = useGetSnippets({ category: 'action' })

  const actionSnippets = useMemo(
    () =>
      (snippets.data?.snippets || []).map((item) => ({
        id: item.id,
        category: 'action' as const,
        file: [],
        snippet: item.snippet as ActionSnippetType['snippet'],
        userId: item.userId || 0,
        value: item.valid,
      })),
    [snippets.data],
  )

  return {
    ...snippets,
    data: actionSnippets,
  }
}
